import { transformDocumentNumber } from '@/components/custom/erp';
import { FormFieldState } from '../hooks';

/**
 * Transform detail rows for API submission
 * @param detailRows - Array of detail row data from the form
 * @returns Transformed detail rows ready for API submission
 */
export const transformDetailRows = (detailRows: MuaHangRecord[], dien_giai: string) => {
  return detailRows.map((row: MuaHangRecord, index: number) => ({
    line: index + 1,
    // uuid: isValidUUID(row.uuid) ? row.uuid : null,

    // Account information
    tk_co: row.tk_co_data?.uuid || row.tk_co || null,

    // Description
    dien_giai: row.dien_giai || dien_giai || null,

    // Quantity and pricing
    so_luong: Number(row.so_luong || 0),
    gia_nt: Number(row.gia_nt || 0),
    tien_nt: Number(row.tien_nt || 0),

    // Organizational
    ma_bp: row.ma_bp_data?.uuid || row.ma_bp || null,
    ma_vv: row.ma_vv_data?.uuid || row.ma_vv || null,
    ma_hd: row.ma_hd_data?.uuid || row.ma_hd || null,
    ma_dtt: row.ma_dtt_data?.uuid || row.ma_dtt || null,
    ma_ku: row.ma_ku_data?.uuid || row.ma_ku || null,
    ma_phi: row.ma_phi_data?.uuid || row.ma_phi || null,
    ma_sp: row.ma_sp_data?.uuid || row.ma_sp || null,
    ma_lsx: row.ma_lsx_data?.uuid || row.ma_lsx || null,
    ma_cp0: row.ma_cp0_data?.uuid || row.ma_cp0 || null
  }));
};

/**
 * Transform all form data for submission
 * @param data - Form data from the form submission
 * @param state - Form field state containing references to selected entities
 * @param detailRows - Array of detail row data
 * @returns Transformed data ready for API submission
 */
export const transformFormData = (
  data: MuaHangRecord,
  state: FormFieldState,
  detailRows: MuaHangRecord[],
  entityUnit: MuaHangRecord,
  so_luong: number,
  thanh_tien: number,
  thue: number,
  tong_tien: number
) => {
  const dien_giai = state.dienGiai || data.dien_giai || '';

  // Transform detail rows
  const detail = transformDetailRows(detailRows, dien_giai);

  // Build the final form data object
  return {
    ...data,
    ...transformDocumentNumber(state.quyenChungTu, state.soChungTu),
    unit_id: entityUnit?.uuid || '',
    ngay_lct: data.ngay_ct || new Date().toISOString().split('T')[0],
    // Supplier information

    ma_kh: state.nhaCungCap?.uuid || null,
    tk: state.taiKhoan?.uuid || state.nhaCungCap?.account_data?.uuid || null,
    ma_tt: state.hanThanhToan?.uuid || state.nhaCungCap?.payment_term_data?.uuid || null,
    dien_giai,

    // Tax information
    ma_thue: state.taxModel?.uuid || null,
    thue_suat: state.taxModel?.thue_suat || 0,
    tk_thue: state.taiKhoanThue?.uuid || null,
    ma_kh9: state.cucThue?.uuid || null,
    ma_tc_thue: state.tinhChatThue?.uuid || null,

    t_so_luong: so_luong,
    t_tien_nt: thanh_tien,
    t_tien: thanh_tien,
    t_thue_nt: thue,
    t_thue: thue,
    t_tt_nt: tong_tien,
    t_tt: tong_tien,

    // Detail arrays
    chi_tiet: detail
  };
};
